import { Box } from "@mui/material";

/**
 * Raqamni ma'lumot sifatida ko'rsatadi.
 *
 * Bu panelning imzo elementi: qoldiq, narx va miqdor -- bu yerdagi eng muhim
 * narsa, shuning uchun ular matndan ajratib teriladi. Mono shrift va tabular
 * raqamlar ustunlar bo'ylab tekis turadi, ya'ni ro'yxatni ko'z bilan taqqoslash
 * mumkin bo'ladi.
 */
export const formatNum = (value, { decimals = 0 } = {}) => {
  const n = Number(value);
  if (value === null || value === undefined || Number.isNaN(n)) return "—";
  // Ming ajratgichi -- ingichka bo'shliq. `ru-RU` uzatadigan uzilmas bo'shliq
  // kengroq va raqamni ikkiga bo'lib ko'rsatadi.
  return n.toLocaleString("ru-RU", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).replace(/\u00A0/g, "\u2009");
};

const Num = ({ value, decimals = 0, suffix, color, weight = 500, size = "0.875rem", sx }) => (
  <Box
    component="span"
    className="num"
    sx={{ fontWeight: weight, fontSize: size, color, whiteSpace: "nowrap", ...sx }}
  >
    {formatNum(value, { decimals })}
    {suffix ? (
      <Box
        component="span"
        sx={{ opacity: 0.55, ml: 0.5, fontSize: "0.62em", fontWeight: 500, letterSpacing: 0 }}
      >
        {suffix}
      </Box>
    ) : null}
  </Box>
);

export default Num;
